import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['description'];

  async create(e) {
    if (this.descriptionTarget.value === '') {
      window.$sendAlert('데이터 다운로드 사유를 적어주세요.');
      document.getElementById('description').focus();
      e.preventDefault();
    } else {
      document.getElementById('register_form').style.display = 'none';
      document.getElementById('result').style.display = '';
    }
  }
}
